(function () {
  'use strict';

  if (window.__nestLreCartAdditiveRepair20260708) return;
  window.__nestLreCartAdditiveRepair20260708 = 'v1-add-missing-lre-only';

  var running = false;
  var pending = false;
  var timer = null;
  var retryCount = 0;
  var maxRetryCount = 20;

  var lreBySize = {
    'Twin': 39478354903121,
    'Twin XL': 39478354935889,
    'Full': 39478354968657,
    'Queen': 39478355001425,
    'King': 39478355034193,
    'Cal King': 39478355066961,
    'Split CK 1-side': 39478355099729
  };

  var sizeByMattressVariant = {
    32778464788561: 'Twin', 32778464821329: 'Twin', 32778464854097: 'Twin', 32778464886865: 'Twin XL', 32778464919633: 'Twin XL', 32778464952401: 'Twin XL', 32778465574993: 'Split CK 1-side', 32778465607761: 'Split CK 1-side', 32778465640529: 'Split CK 1-side', 32778464985169: 'Full', 32778465017937: 'Full', 32778465050705: 'Full', 32778464690257: 'Queen', 32778464723025: 'Queen', 32778464755793: 'Queen', 32778465181777: 'King', 32778465214545: 'King', 32778465247313: 'King', 32778465083473: 'King', 32778465116241: 'King', 32778465149009: 'King', 32778465476689: 'Cal King', 32778465509457: 'Cal King', 32778465542225: 'Cal King', 32778465378385: 'Cal King', 32778465411153: 'Cal King', 32778465443921: 'Cal King',
    32778468556881: 'Twin', 32778468589649: 'Twin', 32778468622417: 'Twin', 32778468655185: 'Twin XL', 32778468687953: 'Twin XL', 32778468720721: 'Twin XL', 32778469343313: 'Split CK 1-side', 32778469376081: 'Split CK 1-side', 32778469408849: 'Split CK 1-side', 32778468753489: 'Full', 32778468786257: 'Full', 32778468819025: 'Full', 32778468458577: 'Queen', 32778468491345: 'Queen', 32778468524113: 'Queen', 32778468950097: 'King', 32778468982865: 'King', 32778469015633: 'King', 32778468851793: 'King', 32778468884561: 'King', 32778468917329: 'King', 32778469245009: 'Cal King', 32778469277777: 'Cal King', 32778469310545: 'Cal King', 32778469146705: 'Cal King', 32778469179473: 'Cal King', 32778469212241: 'Cal King',
    40440621989969: 'Twin', 40440622088273: 'Twin XL', 40440622186577: 'Split CK 1-side', 40440622284881: 'Full', 40440622415953: 'Queen', 40440622514257: 'King', 40440622710865: 'Cal King'
  };

  var lreSizeByVariant = Object.keys(lreBySize).reduce(function (map, size) {
    map[lreBySize[size]] = size;
    return map;
  }, {});

  function mark(name, detail) {
    if (window.NestLreCartTiming && typeof window.NestLreCartTiming.mark === 'function') {
      window.NestLreCartTiming.mark(name, detail);
    }
  }

  function currentPath() {
    return window.location && window.location.pathname ? window.location.pathname.toLowerCase() : '';
  }

  function targetPage() {
    var path = currentPath();
    return /\/products\/[^/]*(sparrow|owl)[^/]*mattress/.test(path) || /\/products\/starling-signature-contour-grid/.test(path);
  }

  function cartMutationUrl(url) {
    return typeof url === 'string' && /\/cart\/(add|change|update|clear)(?:\.js)?(?:\?|$)/.test(url);
  }

  function countRequiredLre(cart) {
    return (cart.items || []).reduce(function (required, item) {
      var size = sizeByMattressVariant[Number(item.variant_id)];
      if (!size) return required;
      required[size] = (required[size] || 0) + Number(item.quantity || 0);
      return required;
    }, {});
  }

  function countActualLre(cart) {
    return (cart.items || []).reduce(function (actual, item) {
      var size = lreSizeByVariant[Number(item.variant_id)];
      if (!size) return actual;
      actual[size] = (actual[size] || 0) + Number(item.quantity || 0);
      return actual;
    }, {});
  }

  function missingLreLines(cart) {
    var required = countRequiredLre(cart);
    var actual = countActualLre(cart);
    var missing = [];

    Object.keys(required).forEach(function (size) {
      var needed = Number(required[size] || 0);
      var current = Number(actual[size] || 0);
      var delta = needed - current;
      if (delta > 0 && lreBySize[size]) {
        missing.push({ size: size, variantId: lreBySize[size], quantity: delta, needed: needed, current: current });
      }
    });

    return missing;
  }

  function addMissingLine(line) {
    mark('LRE additive repair add missing', line);
    return window.fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: line.variantId,
        quantity: line.quantity
      })
    }).then(function (response) {
      if (!response.ok) throw new Error('LRE additive repair add failed: ' + response.status);
      return response.json();
    });
  }

  function refreshCart() {
    window.setTimeout(function () {
      if (typeof window.UpdateCart === 'function') window.UpdateCart();
      window.dispatchEvent(new CustomEvent('refreshAjaxCart'));
    }, 120);
  }

  function run(reason) {
    if (!targetPage() || !window.fetch) return;
    if (running) {
      pending = true;
      return;
    }

    running = true;
    pending = false;

    window.fetch('/cart.js?mrc_raw=1', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var missing = missingLreLines(cart);
        mark('LRE additive repair check', { reason: reason || 'scheduled', missing: missing });
        if (!missing.length) return null;

        return missing.reduce(function (promise, line) {
          return promise.then(function () { return addMissingLine(line); });
        }, Promise.resolve()).then(function () {
          refreshCart();
        });
      })
      .catch(function (error) {
        mark('LRE additive repair error', error && error.message ? error.message : String(error));
      })
      .then(function () {
        running = false;
        if (pending) schedule('pending', 300);
      });
  }

  function schedule(reason, delay) {
    if (!targetPage()) return;
    window.clearTimeout(timer);
    timer = window.setTimeout(function () {
      timer = null;
      run(reason);
    }, typeof delay === 'number' ? delay : 700);
  }

  function scheduleBurst(reason) {
    schedule(reason, 450);
    [1000, 1800, 3200].forEach(function (delay) {
      window.setTimeout(function () { run(reason + ' delayed ' + delay); }, delay);
    });
  }

  function patchFetch() {
    if (!window.fetch || window.fetch.__nestLreCartAdditiveRepair20260708) return;
    var originalFetch = window.fetch;
    window.fetch = function () {
      var input = arguments[0];
      var url = typeof input === 'string' ? input : input && input.url;
      return originalFetch.apply(this, arguments).then(function (response) {
        if (cartMutationUrl(url)) scheduleBurst('after fetch ' + url);
        return response;
      });
    };
    window.fetch.__nestLreCartAdditiveRepair20260708 = true;
  }

  function patchXhr() {
    if (!window.XMLHttpRequest || window.XMLHttpRequest.prototype.__nestLreCartAdditiveRepair20260708) return;
    var proto = window.XMLHttpRequest.prototype;
    var originalOpen = proto.open;
    var originalSend = proto.send;

    proto.open = function (method, url) {
      this.__nestLreAdditiveRepairUrl20260708 = String(url || '');
      return originalOpen.apply(this, arguments);
    };

    proto.send = function () {
      var xhr = this;
      var url = xhr.__nestLreAdditiveRepairUrl20260708 || '';
      if (cartMutationUrl(url)) {
        xhr.addEventListener('loadend', function () {
          scheduleBurst('after xhr ' + url);
        });
      }
      return originalSend.apply(this, arguments);
    };

    proto.__nestLreCartAdditiveRepair20260708 = true;
  }

  function install() {
    patchFetch();
    patchXhr();
    scheduleBurst('initial');
    if (!window.fetch || !window.XMLHttpRequest) {
      retryCount += 1;
      if (retryCount < maxRetryCount) window.setTimeout(install, 100);
    }
    mark('LRE additive repair loaded', currentPath());
  }

  install();
})();
